import React from 'react'
import {NavLink} from "react-router-dom";
import {Car, CarThree, CarTwo, City, Houses, Scooter, Town, Tree, TreeThree, TreeTwo} from "./svgFiles";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

export const Footer = () => {
    const {t} = useTranslation()
    const theme = useSelector(state => state.app.theme)

    return (
        <footer className={theme}>
            <div className="city">
                <Car />
                <CarTwo />
                <CarThree />
                <Scooter />
                <Town />
                <Tree />
                <Houses />
                <TreeThree />
                <City />
                <TreeTwo />
                <Town />
            </div>
            <div className="content-wrapper">
                <div className="content footer">
                    <div className="footer-flex">
                        <div className="footer-flex-logo">
                            Forset
                        </div>
                        <ul className="footer-flex-list">
                            <li className="footer-flex-list__item"><NavLink to="/carslist" activeClassName="current" >{t('cars')}</NavLink></li>
                            <li className="footer-flex-list__item"><NavLink to="/clientslist" activeClassName="current" >{t('allClients')}</NavLink></li>
                            <li className="footer-flex-list__item"><NavLink to="/orders" activeClassName="current">{t('orders')}</NavLink></li>
                            <li className="footer-flex-list__item"><NavLink to="/analytics" activeClassName="current" >{t('analytics')}</NavLink></li>
                            <li className="footer-flex-list__item"><NavLink to="/authorization" activeClassName="current" >{t('clients')}</NavLink></li>
                        </ul>

                        <div className="footer-flex-rools">
                            Privacy Policy <br />
                            Terms & Conditions
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
